<label *ngIf="label" [for]="labelId">{{ label }}</label>
<textarea
  [id]="labelId"
  [formControl]="control"
  class="form-control"
  [class.light]="lightMode"
  [disabled]="disabled"
  [readonly]="readonly"
  rows="4"
></textarea>
